export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  function formatDate(el) {
    const dateText = el.text().trim(); // Trim whitespace from the date text

    // Check if the date text contains a range
    if (dateText.includes(' - ')) {
      const [dateOne, dateTwo] = dateText.split(' - ');
      const monthStart = dateOne.slice(0, 3);
      const monthEnd = dateTwo.slice(0, 3);
      const dayStart = dateOne.match(/\d+/)[0]; // Extract numeric day from first date
      const dayEnd = dateTwo.match(/\d+/)[0]; // Extract numeric day from second date

      if (monthStart === monthEnd) {
        el.html(`${monthStart}<span class="days">${dayStart}-${dayEnd}</span>`);
      } else {
        el.html(
          `<div>${monthStart}<span class="days">${dayStart}</span></div>
           - 
          <div>${monthEnd}<span class="days">${dayEnd}</span></div>`,
        );
      }
      el.addClass('date-range' + (monthStart !== monthEnd ? ' double' : ''));
    } else {
      // Handle single day event
      const month = dateText.slice(0, 3);
      const day = dateText.match(/\d+/)[0]; // Extract numeric day
      el.html(`${month}<span class="days">${day}</span>`);
      el.addClass('date-single');
    }
  }

  $(`#${widgetName}`).append('<div class="multiFeatureContent">  <h1>Upcoming Events</h1></div>');
  setTimeout(function () {
    $('.all-events-btn').wrap("<div class='events-btn-wrap'></div>");
  }, 2000);
  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    allEventsLink: true,
    allEventsLinkText: 'View Full Calendar',
    hasImages: false,
    imageBackground: false,
    lazyLoadImages: true,
    buyNowButton: { visible: false, text: '>' },
    moreButton: { visible: false, text: 'MORE' },
    maxItemsVisible: 5,
    isResponsive: false,
    hasDescription: false,
    textContainer: true,
    link: 'all', //options are 'all', 'text', 'image', 'imageAndText', or ''
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      console.log(data);
      // use function below if "more" text needs to appear at end of description text

      $('#multiScheduleFeature .featureItem').each(function () {
        // Reference to the current featureItem element
        let featureItem = $(this);
        let itemDescripton = featureItem.find('.featureItemDescription');
        let itemtittle = featureItem.find('.featureItemTitle');
        //uncomment below if you need to slice the date string up into something shorter like "Oct 31"
        let eventDate = $(this).find($('span.featureItemDate'));
        formatDate(eventDate);

        let characterLimitTitle = 40;
        let itemTitleText = itemtittle.text();
        if (itemTitleText.length > characterLimitTitle) {
          let trimmedTextTitle = itemTitleText.substring(0, characterLimitTitle) + '...';
          itemtittle.text(trimmedTextTitle);
        }

        // Limit character length of item description
        let characterLimitDescription = 35;
        let itemDescriptonText = itemDescripton.text();
        if (itemDescriptonText.length > characterLimitDescription) {
          let trimmedTextDescription =
            itemDescriptonText.substring(0, characterLimitDescription) + '...';
          itemDescripton.text(trimmedTextDescription);
        }

        // uncomment below if 'more' link is needed after event description
        // itemDescripton.append("<span class='more-text'>More</span>");
      });
    },
  });
}
